/**
 * Plugin that makes part of the page look like 3D scrolling
 */
export default class MoveIt {
    /**
     * Constructor
     */
    constructor()
    {
        this.init();
    }

    /**
     * Init function
     */
    init()
    {
        // Create plugin
        (function ( $ ) {
            $.fn.moveIt = function () {

                let $window = $(window);
                let instances = [];

                $(this).each(function () {
                    instances.push(new moveItItem($(this)));
                });

                window.onscroll = function () {
                    let scrollTop = $window.scrollTop();
                    instances.forEach(function (inst) {
                        inst.update(scrollTop);
                    });
                }
            }

            let moveItItem = function (el) {

                this.el = $(el);
                this.speed = parseInt(this.el.attr('data-scroll-speed'));
            };

            moveItItem.prototype.update = function (scrollTop) {
                this.el.css('transform', 'translateY(' + (scrollTop / this.speed) + 'px)');
            };
        }( jQuery ));
    }
}